import { render, staticRenderFns } from "./VTextField.vue?vue&type=template&id=e08421e2&scoped=true&lang=pug"
import script from "./VTextField.vue?vue&type=script&lang=js"
export * from "./VTextField.vue?vue&type=script&lang=js"
import style0 from "./VTextField.vue?vue&type=style&index=0&id=e08421e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08421e2",
  null
  
)

export default component.exports